const SITE_SWAL = {
  customClass: {
    popup: "site-swal",
    title: "site-swal__title",
    htmlContainer: "site-swal__body",
    icon: "site-swal__icon",
    actions: "site-swal__actions",
    confirmButton: "site-swal__confirm",
    cancelButton: "site-swal__cancel",
    closeButton: "site-swal__close",
  },
  buttonsStyling: false,
  confirmButtonText: "Compris",
  width: "440px",
  padding: "1.75rem 1.75rem 1.5rem",
  showClass: {
    popup: "site-swal-show",
  },
  hideClass: {
    popup: "site-swal-hide",
  },
}

const SITE_SWAL_MARKS = {
  warning: '<div class="site-swal-mark site-swal-mark--warning" aria-hidden="true"><span>!</span></div>',
  success: '<div class="site-swal-mark site-swal-mark--success" aria-hidden="true"><span>✓</span></div>',
}

const applySiteSwalMark = (opts, kind) => {
  const next = { ...opts }
  delete next.icon
  next.iconHtml = SITE_SWAL_MARKS[kind]
  return next
}

const inferSiteSwalPresentation = (opts) => {
  const text = [opts.title, opts.html, opts.text].filter(Boolean).join(" ")
  let next = { ...opts }

  if (opts.iconHtml || opts.icon === false) return next
  if (opts.icon != null) return next

  if (/bien été enregistr|enregistrées|enregistré/i.test(text)) {
    next = applySiteSwalMark(next, "success")
  } else if (/Veuillez|Impossible|incorrect|ne correspond|ne peut pas|dépasse|sélectionner/i.test(text)) {
    if (!next.title) next.title = "Attention"
    next = applySiteSwalMark(next, "warning")
  } else if (next.html || next.text) {
    next.icon = false
  }

  return next
}

const mergeSiteSwal = (rawOpts) => {
  const opts = typeof rawOpts === "string" ? { title: rawOpts } : { ...(rawOpts || {}) }

  if (opts.customClass?.popup === "backoffice-swal") return opts

  return inferSiteSwalPresentation({
    ...SITE_SWAL,
    ...opts,
    customClass: {
      ...SITE_SWAL.customClass,
      ...(opts.customClass || {}),
    },
  })
}

const showSiteAlert = (opts) => {
  if (typeof Swal === "undefined") {
    const message = opts?.html || opts?.text || opts?.title || ""
    window.alert(String(message).replace(/<[^>]+>/g, ""))
    return Promise.resolve({ isConfirmed: true })
  }

  return Swal.fire(mergeSiteSwal(opts))
}

const initSiteSwal = () => {
  if (typeof Swal === "undefined" || Swal.__siteSwalPatched) return
  Swal.__siteSwalPatched = true

  const nativeFire = Swal.fire.bind(Swal)
  Swal.fire = (opts) => {
    const normalized = typeof opts === "string" ? { title: opts } : opts || {}
    if (document.body?.classList.contains("backoffice-body")) {
      return nativeFire(normalized)
    }
    return nativeFire(mergeSiteSwal(normalized))
  }
}

export { SITE_SWAL, showSiteAlert, initSiteSwal }
